import React from 'react';
import { useHistory } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { generateFormattedExcerpt, generatePlainTextExcerpt } from '../../../utils/excerptUtils';
import { formatDateOnlyCT } from '../../../utils/dateUtils';

const PostCard = ({ post }) => {
  const history = useHistory();
  
  if (!post) return null;

  const formattedExcerpt = generateFormattedExcerpt(post.content, 240);
  const fallbackExcerpt = generatePlainTextExcerpt(post.content, 240, 4).replace(/\n/g, '<br />');
  const excerptHtml = formattedExcerpt || fallbackExcerpt;
  const postedDate = formatDateOnlyCT(post.posted_at);
  const wasUpdated = post.updated_at && post.posted_at && 
    new Date(post.updated_at) > new Date(post.posted_at);
  
  const postUrl = `/ai-notes/${post.slug || post.id}`;
  
  const handleCardClick = (e) => {
    // Don't navigate if clicking on a link
    if (e.target.tagName === 'A' || e.target.closest('a')) {
      return;
    }
    history.push(postUrl);
  };

  return (
    <Card 
      onClick={handleCardClick}
      style={{
        border: 'none',
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        height: '100%',
        overflow: 'hidden',
        cursor: 'pointer'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
      }}
    >
      {post.image && (post.image.webp_url || post.image.s3_url) && (
        <div style={{
          width: '100%',
          height: '200px',
          overflow: 'hidden',
          backgroundColor: '#f7fafc'
        }}>
          <img
            src={post.image.webp_url || post.image.s3_url}
            alt={post.title}
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'scale(1)';
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}
      <Card.Body style={{ padding: '2rem' }}>
        <div style={{
          fontSize: '0.875rem',
          color: '#718096',
          marginBottom: '0.75rem',
          fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
        }}>
          {postedDate}
          {wasUpdated && (
            <span style={{ marginLeft: '0.5rem', fontStyle: 'italic' }}>
              (updated)
            </span>
          )}
        </div>
        {/* Tags */}
        {post.tags && post.tags.length > 0 && (
          <div style={{ marginBottom: '0.75rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {post.tags.map((tag, index) => (
              <span
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  window.location.href = `/ai-notes?tag=${encodeURIComponent(tag)}`;
                }}
                style={{
                  display: 'inline-block',
                  padding: '2px 10px',
                  backgroundColor: '#edf2f7',
                  color: '#4a5568',
                  borderRadius: '12px',
                  fontSize: '0.75rem',
                  fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#667eea';
                  e.target.style.color = '#fff';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#edf2f7';
                  e.target.style.color = '#4a5568';
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        )}
        <Card.Title style={{
          fontSize: '1.5rem',
          fontWeight: '600',
          color: '#2d3748',
          marginBottom: '1rem',
          fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
          lineHeight: '1.3'
        }}>
          {post.title}
        </Card.Title>
        <Card.Text
          as="div"
          className="post-card-excerpt ql-content"
          style={{
            color: '#4a5568',
            lineHeight: '1.6',
            marginBottom: '1.5rem',
            fontSize: '0.95rem',
            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
            padding: 0
          }}
          dangerouslySetInnerHTML={{ __html: excerptHtml }}
        />

        <div style={{
          color: '#667eea',
          fontWeight: '500',
          fontSize: '0.9rem',
          fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
          display: 'inline-flex',
          alignItems: 'center'
        }}>
          Read More →
        </div>
      </Card.Body>
    </Card>
  );
};

export default PostCard;

